import { BaseRedomElement } from "../../utils/base-redom-element.js";
import { DeliveryOption } from "./delivery-option.js";
import { DeliverySelectorStateManager } from "./delivery-selector-state-manager.js";
import { IDeliveryGroup } from "../../api/estore/checkout/interfaces/delivery-group-interface.js";
import { ICmsDeliverySelectorConfiguration } from "./interfaces/cms-delivery-selector-config-interface.js";
import { el } from "../../lib/redom.es.min.js";

export class DeliveryOptionList extends BaseRedomElement {
    config: ICmsDeliverySelectorConfiguration;
    stateManager: DeliverySelectorStateManager;
    translations: any;
    group: IDeliveryGroup;
    optionEls: DeliveryOption[];
    root: Node;

    constructor(config: ICmsDeliverySelectorConfiguration, stateManager: DeliverySelectorStateManager, translations: any, group: IDeliveryGroup) {
        super(config.useShadowRoot);
        this.config = config;
        this.root = this.config.useShadowRoot ? this.shadowRoot : this;
        this.stateManager = stateManager;
        this.translations = translations;
        this.group = group;
        this.attachDelegates();
        this.setSelected(group.selected);
    }

    attachDelegates() { 
        this.stateManager.selectedGroupDelegates.push(
            (_, newGroupId) => this.setSelected(this.group.id === newGroupId));
    }

    connectedCallback() {
        this.render();
    }

    render() {
        const opts = this.group.options;

        const children = [
            this.config.useShadowRoot ? el("link", { rel: "stylesheet", href: this.config.cssFiles.optionList}) : null,
            el("h3", this.translations.titleOptions),
            el("div.options", 
                ...opts.map(o => new DeliveryOption(this.config, this.stateManager, this.translations, o))
            )
        ];
        
        this.mountArray(this.root, children);
    }

    setSelected(selected: boolean) {
        const c = "selected";
        const cl = this.classList;
        selected ? cl.add(c) : cl.remove(c);
    }
}

customElements.define("delivery-option-list", DeliveryOptionList);